var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.number),expression:"number"}],class:_vm.fieldClass,attrs:{"type":"float","readonly":_vm.readonly},domProps:{"value":(_vm.number)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.number=$event.target.value},function($event){_vm.toFixed(_vm.size)}]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aba4682","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/components/InputFloat.vue
// module id = 1022
// module chunks = 1